<template>
    <div class='preheat_content'>
        <div class='preheat_mian'>
            <div class="banner"></div>
            <i class='preheat_mian-back'
               @click="clickBack"></i>
            <div class='preheat_guide-wrap'>
                <div class="preheat_guide-con">
                    <p><strong>1</strong>活动时间：<span>2024年1月15日00:00:00至 2024年2月29日12:00:00</span></p>
                    <p><strong>2</strong>活动期间，学生完成的寒假作业数量越多， 老师可抽取的奖品越多。</p>
                    <p><strong>3</strong>本活动短信邀请次数计入当月发作业次数。</p>
                    <div class='preheat_guide-con-btn'
                         @click="clickBth">设置定时邀请短信</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">

export default {
    data () {
        return {

        };
    },
    methods: {
        clickBack () {
            this.appFunction("ys_finish");
        },
        clickBth () {
            this.$router.push('/activity/2023winter/timing');
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.preheat_content {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 64px / $ppr;
    background: #dc2b17;
    position: relative;
    z-index: 1;

    .preheat_mian {
        position: relative;
        z-index: 3;
        .banner {
            height: 1113px / $ppr;
            background: url("./img/2023winter-bg.jpg") no-repeat;
            background-size: 100% 100%;
        }
        .preheat_mian-back {
            width: 38px / $ppr;
            height: 56px / $ppr;
            background: url("./img/icon_img_04.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            left: 24px / $ppr;
            top: 32px / $ppr;
        }
        .preheat_guide-wrap {
            height: 1035px / $ppr;
            margin: -95px / $ppr 22px / $ppr 0;
            background: url("./img/guide-bg.png") no-repeat;
            background-size: 100% 100%;
            .preheat_guide-con {
                padding: 503px / $ppr 40px / $ppr 0;

                p {
                    font-size: 26px / $ppr;
                    color: #333;
                    line-height: 1.7;
                    padding-left: 65px / $ppr;
                    position: relative;
                    margin-bottom: 27px / $ppr;
                    strong {
                        position: absolute;
                        left: 0;
                        display: inline-block;
                        width: 44px / $ppr;
                        height: 44px / $ppr;
                        font-size: 30px / $ppr;
                        color: #ffeccf;
                        text-align: center;
                        line-height: 44px / $ppr;
                        border-radius: 44px / $ppr;
                        background: #dc2b17;
                        font-weight: bold;
                    }
                    span {
                        color: #dc2b17;
                    }
                }
                .preheat_guide-con-btn {
                    width: 434px / $ppr;
                    height: 115px / $ppr;
                    margin: 80px / $ppr auto 0;
                    background: url("./img/btn-bg.png") no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    color: #fff;
                    padding-top: 20px / $ppr;
                    box-sizing: border-box;
                }
            }
        }
    }
}
</style>